import en from "../../messages/en.json";

export type Messages = typeof en;

export function getMessages(): Messages {
  return en;
}

export function t(template: string, vars: Record<string, string | number> = {}): string {
  return template.replace(/\{(\w+)\}/g, (_, key) => String(vars[key] ?? ""));
}
